module.exports = __webpack_public_path__ + "img/update_bg_pic_upload.daab4d95.png";